<template>
  <section class="continue_30">
    <div>
      <img src="@/auto/assets/image/49/1_1.5x.png" style="width: 100%" />
    </div>
  </section>
</template>

<script>
export default {
  name: 'Continue',
}
</script>

<style lang="less" scoped>
.continue_30 {
  // height: 1080px;
  width: 100%;
  position: relative;
  background-color: #111;
  overflow: hidden;
}
</style>

<!-- <template>
  <section class="continue_49">
    <div class="content_box">
      <h3>精彩继续</h3> 
      <div class="f-row f-row-center">
        <img src="@/auto/assets/image/more.png"/>
      </div>  
      <div class="f-row f-row-center">
        <ul class="announce">
        <li>本页面中部分产品界面和功能说明可能因系统版本、机型不同而存在差异，请以实际呈现效果为准。</li>
        <li>
          本页面所展示的内容和功能，无法保证提供永久服务。可能因版权、商务或技术条件的变化而调整，请以产品实际内容和功能为准。
        </li>
      </ul>
      </div>  
    </div>
  </section>
</template>

<script>


export default {
  name: 'Continue',
}
</script>

<style lang="less" scoped>

.continue_49 {
  height: 1080px;
  width: 100%;
  position: relative;
  background-color: #F7F8FA;
  overflow: hidden;
  .announce {
    margin-top: 3.76rem;
    width: 71rem;
    color: #ACACAC;
    font-family: Flyme Sans VF;
    font-size: 1.25rem;
    font-style: normal;
    font-weight: 400;
    line-height: 1.875rem; /* 150% */
  letter-spacing: 0.0625rem;
  }
  
  .content_box {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 1200px;
    height: 100%;

    h3 {
      font-size: 5rem;
      line-height: 6.75rem; /* 135% */
      letter-spacing: 0.25rem;
      font-weight: 700;
      font-family: Flyme Sans VF;
      font-style: normal;
      text-align: center;
      color: #000000;
      margin: 10rem 0 7.5rem 0;
    }
    img {
      width: 75rem;
    }
  }

  ul {
    display: block;
    list-style-type: disc;
    // margin-block-start: 1em;
    // margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    // padding-inline-start: 40px;
  }
}
</style> -->
